<template>
  <div class="nuttrema-layout-schedules" :class="[ theme ? `theme-${theme}` : '' ]">
    <slot name="overflow"></slot>
    <div
      v-if="slots.west"
      class="nuttrema-layout-schedules__west"
      :style="style.west"
      :class="{ 'collapsed': !options.showWest && !minWidthWest, 'fold': !options.showWest && minWidthWest }"
    >
      <div
        class="nuttrema-layout-schedules__west__content"
        :class="{ 'collapsed': !options.showWest && !minWidthWest, 'fold': !options.showWest && minWidthWest, 'is-popover': options.popoverWest }"
      >
        <slot name="west"></slot>
      </div>
      <div class="nuttrema-layout-schedules__west__fold" @click="toggleWest">
        <slot name="west-fold"></slot>
      </div>
      <button-resize-toggler @click="toggleWest" :collapsed="!options.showWest"></button-resize-toggler>
    </div>
    <div
      v-if="slots.central"
      class="nuttrema-layout-schedules__central"
      :class="{ 'west-expanded': slots.west && options.showWest, 'east-expanded': slots.east && options.showEast, 'top-expanded': slots.top && options.showTop }"
    >
      <div
        v-if="slots.centralTop"
        class="nuttrema-layout-schedules__central__top"
        :class="{ 'collapsed': !options.showTop }"
      >
        <div class="nuttrema-layout-schedules__central__top__content">
          <slot name="central-top"></slot>
        </div>
        <button-resize-toggler class="is-top-side" @click="toggleTop" :collapsed="!options.showTop"></button-resize-toggler>
      </div>

      <div class="nuttrema-layout-schedules__central__middle">
        <slot name="central"></slot>
      </div>
    </div>
    <div
      v-if="slots.east && enableEast"
      class="nuttrema-layout-schedules__east"
      :style="style.east"
      :class="{ 'collapsed': !options.showEast && !minWidthEast, 'fold': !options.showEast && minWidthEast, 'is-popover': options.popoverWest }"
    >
      <div class="nuttrema-layout-schedules__east__content">
        <slot name="east"></slot>
      </div>
      <div class="nuttrema-layout-schedules__east__fold" @click="toggleEast">
        <slot name="east-fold"></slot>
      </div>
      <button-resize-toggler
        v-if="toggleShowEast"
        class="is-right-side"
        @click="toggleEast"
        :collapsed="!options.showEast"
      ></button-resize-toggler>
    </div>
  </div>
</template>

<script>
import { has } from 'lodash';
import ButtonResizeToggler from 'components/ui/button/button-resize-toggler';

export default {
  name: 'nuttrema-layout-schedules',
  props: {
    showTop: {
      type: Boolean,
      required: false,
      default: false,
    },
    showWest: {
      type: Boolean,
      required: false,
      default: true,
    },
    popoverWest: {
      type: Boolean,
      required: false,
      default: false,
    },
    widthWest: {
      type: String,
      required: false,
      default: '24em',
    },
    minWidthWest: {
      type: String,
      required: false,
      default: null,
    },
    showEast: {
      type: Boolean,
      required: false,
      default: false,
    },
    toggleShowEast: {
      type: Boolean,
      required: false,
      default: true,
    },
    popoverEast: {
      type: Boolean,
      required: false,
      default: true,
    },
    widthEast: {
      type: String,
      required: false,
      default: '24em',
    },
    minWidthEast: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    enableEast: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    ButtonResizeToggler,
  },
  data() {
    return {
      options: {
        showTop: this.showTop,
        showWest: this.showWest,
        popoverWest: this.popoverWest,
        showEast: this.showEast,
        popoverEast: this.popoverEast,
      },
      // style: {
      //   west: null,
      //   east: null,
      // },
      slots: {
        west: false,
        east: false,
        top: false,
        central: false,
        centralTop: false,
      },
    };
  },
  methods: {
    toggleTop() {
      this.options.showTop = !this.options.showTop;
    },
    toggleWest() {
      this.options.showWest = !this.options.showWest;
    },
    toggleEast() {
      this.options.showEast = !this.options.showEast;
    },
    checkSlot(slot) {
      return has(this.$slots, slot) && this.$slots[slot][0].tag !== undefined;
    },
  },
  computed: {
    style() {
      const widthWest = this.options.showWest
        ? this.widthWest
        : this.minWidthWest || 0;
      const widthEast = this.options.showEast
        ? this.widthEast
        : this.minWidthEast || 0;

      return {
        west: `flex: 0 0 ${widthWest}; width: ${widthWest};`,
        east: `flex: 0 0 ${widthEast}; width: ${widthEast};`,
      };
    },
  },
  watch: {
    showTop(value) {
      this.options.showTop = value;
    },
    showWest(value) {
      this.options.showWest = value;
    },
    showEast(value) {
      this.options.showEast = value;
    },
  },
  created() {
    console.log('this.$slots', this.$slots);
    this.slots.top = this.checkSlot('top');
    this.slots.west = this.checkSlot('west');
    this.slots.east = this.checkSlot('east');
    this.slots.central = this.checkSlot('central');
    this.slots.centralTop = this.checkSlot('central-top');
    // this.style = {
    //   west: `flex: 0 0 ${this.widthWest}; width: ${this.widthWest}; min-width: ${this.minWidthWest || 'inherit'}`,
    //   east: `flex: 0 0 ${this.widthEast}; width: ${this.widthEast}; min-width: ${this.minWidthWest || 'inherit'}`,
    // };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/theme/colors';
@import '~styles/mixins/mixins';

$stripe-bg: #fafbfd;

.nuttrema-layout-schedules {
  flex-grow: 1;
  display: flex;
  position: relative;
  align-self: stretch;
  background-color: #fff;
  justify-content: space-between;
  height: 100%;

  .nuttrema-layout-schedules__west {
    z-index: 2;
    display: flex;
    position: relative;
    align-self: stretch;
    transition-property: all;
    transition-duration: 100ms;

    .nuttrema-layout-schedules__west__content,
    .nuttrema-layout-schedules__west__fold {
      opacity: 1;
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      background-color: #fcfcfc;
      border-right: 2px solid #dbe2ef;
      flex-direction: column;
    }

    .nuttrema-layout-schedules__west__fold {
      opacity: 0;
      display: none;
      &:hover {
        cursor: pointer;
      }
    }

    &.collapsed {
      flex: 0 0 0 !important;
      .nuttrema-layout-schedules__west__content {
        opacity: 0;
        display: none;
      }
    }

    &.fold {
      .nuttrema-layout-schedules__west__content {
        opacity: 0;
        display: none;
      }
      .nuttrema-layout-schedules__west__fold {
        opacity: 1;
        display: flex;
      }
    }

    &.is-popover {
      left: 0;
    }
  }

  .nuttrema-layout-schedules__central {
    z-index: 1;
    // height: 100%;
    flex-grow: 1;
    display: flex;
    position: relative;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;

    @include background-stripe($stripe-bg, #fff, 7em, 7.001em);

    > * {
      z-index: 1;
    }

    .nuttrema-layout-schedules__central__top {
      opacity: 1;
      display: flex;
      flex-shrink: 0;
      position: relative;
      align-self: stretch;
      .nuttrema-layout-schedules__central__top__content {
        opacity: 1;
        flex-grow: 1;
        display: flex;
        align-self: stretch;
      }
      &.collapsed {
        .nuttrema-layout-schedules__central__top__content {
          display: none;
          opacity: 0;
        }
      }
    }
    .nuttrema-layout-schedules__central__middle {
      height: 1px;
      flex-grow: 1;
      display: flex;
      margin-top: 1em;
      overflow-y: auto;
      position: relative;
      align-self: stretch;
      @supports (-moz-appearance: none) {
        height: calc(100vh - 80px);
      }
    }
    .nuttrema-layout-schedules__central__bottom {
      display: flex;
      align-self: stretch;
    }
  }

  .nuttrema-layout-schedules__east {
    z-index: 2;
    display: flex;
    position: relative;
    align-self: stretch;
    transition-property: all;
    transition-duration: 100ms;

    .nuttrema-layout-schedules__east__content,
    .nuttrema-layout-schedules__east__fold {
      opacity: 1;
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      background-color: #fcfcfc;
      border-left: 2px solid #dbe2ef;
      flex-direction: column;
    }

    .nuttrema-layout-schedules__east__fold {
      opacity: 0;
      display: none;
      &:hover {
        cursor: pointer;
      }
    }

    &.collapsed {
      flex: 0 0 0 !important;
      .nuttrema-layout-schedules__east__content {
        display: none;
        opacity: 0;
      }
    }

    &.fold {
      .nuttrema-layout-schedules__east__content {
        opacity: 0;
        display: none;
      }
      .nuttrema-layout-schedules__east__fold {
        opacity: 1;
        display: flex;
      }
    }

    &.is-popover {
      right: 0;
    }
  }

  .vertical-fold-content {
    writing-mode: vertical-lr;
    -webkit-writing-mode: vertical-lr;
    display: flex;
    align-items: center;
    padding-top: 0.75em;
    p {
      color: #7a7a7a;
      font-size: 0.8em;
      font-weight: 500;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      &.is-left {
        transform: scale(-1);
      }
    }
  }

  .schedule-day-title {
    margin: 1em 1em 1em 8em;
    .ttl {
      font-weight: 500;
      font-size: 1.25rem;
    }
    .dsc {
      color: $gray-light;
      font-size: 1rem;
    }
  }

  &.is-popover {
    top: 0;
    z-index: 9;
    position: absolute;
    height: 100%;
    &.collapsed {
      flex: 0 0 0;
      width: 0;
    }
  }

  &.nuttrema-layout-schedules--wide-stripe {
    .nuttrema-layout-schedules__central {
      @include background-stripe($stripe-bg, #fff, 10em, 10.001em);
    }
  }

  &.is-no-middle-margin-top {
    .nuttrema-layout-schedules__central {
      .nuttrema-layout-schedules__central__middle {
        margin-top: 0;
      }
    }
  }

  &.is-no-wide-stripe {
    .nuttrema-layout-schedules__central {
      background: none;
    }
  }

  &.is-east-scroll {
    .nuttrema-layout-schedules__east {
      .nuttrema-layout-schedules__east__content {
        overflow-y: auto;
      }
    }
  }

  &.is-transparent {
    background-color: transparent;
    .nuttrema-layout-schedules__central {
      background: transparent;
      &:after {
        background: transparent;
      }
    }
  }

  &.theme-dc-logo {
    .nuttrema-layout-schedules__central {
      &:after {
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        content: '';
        height: 100%;
        opacity: 0.1;
        position: absolute;
        background: transparent url('~assets/images/dc-logo-bg.svg') no-repeat;
        background-position: right -6em bottom -8em;
        background-size: 42em;
      }
    }
  }
  // end ~ theme-dc-logo
}
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-schedules.vue